import { useMemo } from 'react';
import { LucideIcon } from 'lucide-react';

interface NavSectionData {
    section: string;
    icon: LucideIcon;
    items: any[];
}

export const useSidebarSections = (navItems: any[]): NavSectionData[] => {
    return useMemo(() => {
        const sections: NavSectionData[] = [];
        let currentSection: NavSectionData | null = null;

        navItems.forEach((item) => {
            if ('section' in item) {
                if (currentSection) sections.push(currentSection);
                currentSection = { section: item.section, icon: item.icon, items: [] };
            } else if (currentSection) {
                currentSection.items.push(item);
            }
        });
        if (currentSection) sections.push(currentSection);

        return sections;
    }, [navItems]);
};
